module.exports = __webpack_public_path__ + "img/sub29.1d8a8155.jpg";